import { render, staticRenderFns } from "./AssignmentInfoEditErrorModal.vue?vue&type=template&id=b5d389e2&scoped=true&"
import script from "./AssignmentInfoEditErrorModal.vue?vue&type=script&lang=js&"
export * from "./AssignmentInfoEditErrorModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentInfoEditErrorModal.vue?vue&type=style&index=0&id=b5d389e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d389e2",
  null
  
)

export default component.exports